import { Chart } from "react-chartjs-2";
import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { MoreVertical } from "react-feather";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useLead from "../../../hooks/useLead";
import { green, red, orange, pink, purple, blue, grey } from "@mui/material/colors";
import {
  Card as MuiCard,
  CardContent as MuiCardContent,
  CardHeader,
  IconButton,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableHead,
  TableRow as MuiTableRow,
  Typography,
} from "@mui/material";
import { spacing } from "@mui/system";

const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)`
  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(2)};
  }
`;

const ChartWrapper = styled.div`
  height: 168px;
  position: relative;
`;

const DoughnutInner = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -22px;
  text-align: center;
  z-index: 0;
`;

const TableRow = styled(MuiTableRow)`
  height: 42px;

  &:last-child th,
  &:last-child td {
    border-bottom: 0;
  }
`;

const TableCell = styled(MuiTableCell)`
  padding-top: 0;
  padding-bottom: 0;
`;

const GreenText = styled.span`
  color: ${() => green[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const PinkText = styled.span`
  color: ${() => pink[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const RedText = styled.span`
  color: ${() => red[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const PurpleText = styled.span`
  color: ${() => purple[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const BlueText = styled.span`
  color: ${() => blue[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const GreyText = styled.span`
  color: ${() => grey[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const OrangeText = styled.span`
  color: ${() => orange[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const Stats = ({ theme }) => {
  const stheme = useTheme();
  const { t } = useTranslation();
  const { state } = useLocation();

  const currentPayload = {
    filters: [
      {
        fieldName: "leadId",
        fieldValue: state?.id,
        op: "eq",
        dataType: "int",
        condition: "and",
        isJoin: true,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "leadStatsId",
        sort: "DESC",
      },
    ],
  };
  const [] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { getAllLeadStats, leadStats, downloadFile } = useLead();
  const [payload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllLeadStats(payload);
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  console.log(leadStats, "hhjklllllllllj");

  const data = {
    labels: ["Total", "Open", "Confirmed", "Interested", "Not Interested", "Closed"],
    datasets: [
      {
        data: [260, 125, 164],
        backgroundColor: [stheme.palette.secondary.main, red[500], orange[500]],
        borderWidth: 5,
        borderColor: stheme.palette.background.paper,
      },
    ],
  };

  const [graphData, setGraphData] = useState(data);

  useEffect(() => {
    const data = {
      labels: ["Total", "Open", "Confirmed", "Interested", "Not Interested", "Closed"],
      datasets: [
        {
          data: [
            leadStats.total,
            leadStats.open,
            leadStats.confirmed,
            leadStats.interested,
            leadStats.notInterested,
            leadStats.closed,
          ],
          backgroundColor: [
            stheme.palette.secondary.main,
            red[500],
            orange[500],
            pink[500],
            green[500],
            purple[500],
          ],
          borderWidth: 5,
          borderColor: stheme.palette.background.paper,
        },
      ],
    };
    //Set graph data
    setGraphData(data);
  }, [leadStats]);

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: "80%",
  };

  return (
    <Card mb={6}>
      <CardHeader
        action={
          <IconButton aria-label="settings" size="large">
            <MoreVertical />
          </IconButton>
        }
        title={t("lead_stats")}
      />
      <CardContent theme={stheme}>
        <ChartWrapper>
          <DoughnutInner>
            <Typography variant="h4">{leadStats.total}</Typography>
            <Typography variant="caption">Total</Typography>
          </DoughnutInner>
          <Chart type="doughnut" data={graphData} options={options} />
        </ChartWrapper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>List</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                Total
              </TableCell>
              <TableCell align="right">
                <BlueText theme={stheme}>{leadStats.total}</BlueText>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Open
              </TableCell>
              <TableCell align="right">
                <RedText theme={stheme}>{leadStats.open}</RedText>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Confirmed
              </TableCell>
              <TableCell align="right">
                <OrangeText theme={stheme}>{leadStats.confirmed}</OrangeText>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Interested
              </TableCell>
              <TableCell align="right">
                <PinkText theme={stheme}>{leadStats.interested}</PinkText>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Not Interested
              </TableCell>
              <TableCell align="right">
                <GreenText theme={stheme}>{leadStats.notInterested}</GreenText>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Closed
              </TableCell>
              <TableCell align="right">
                <PurpleText theme={stheme}>{leadStats.closed}</PurpleText>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default Stats;
